(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["featured-collection"] && !Shopify.designMode) return;
  try {
    
/* Extend the theme's existing slider; its buttons and touch scrolling stay native. */
if (!customElements.get('woodenlux-desktop-carousel')) {
  customElements.define('woodenlux-desktop-carousel', class extends HTMLElement {
    connectedCallback() {
      this.connectionController = new AbortController();
      const initialize = () => { this.initFrame = requestAnimationFrame(() => this.init()); };
      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', initialize, {
          once: true, signal: this.connectionController.signal
        });
      } else initialize();
    }

    init() {
      if (!this.isConnected || this.controller) return;
      this.slider = this.querySelector('slider-component');
      this.track = this.slider?.querySelector('ul.slider--desktop');
      if (!this.track) return;
      this.controller = new AbortController();
      const signal = this.controller.signal;
      this.desktop = matchMedia('(min-width: 990px)');
      this.suppressUntil = 0;
      this.queueUpdate = () => {
        cancelAnimationFrame(this.updateFrame);
        this.updateFrame = requestAnimationFrame(() => this.update());
      };
      this.initDesktopControls(signal);
      this.desktop.addEventListener('change', () => {
        this.finishDrag();
        this.queueUpdate();
      }, { signal });
      this.track.addEventListener('pointerdown', event => this.startDrag(event), { signal });
      this.track.addEventListener('dragstart', event => {
        if (this.canDrag() && !this.isControl(event.target) &&
            !event.ctrlKey && !event.metaKey && !event.altKey && !event.shiftKey) event.preventDefault();
      }, { signal });
      this.track.addEventListener('click', event => {
        if (event.detail > 0 && performance.now() < this.suppressUntil) {
          event.preventDefault();
          event.stopImmediatePropagation();
          this.suppressUntil = 0;
        }
      }, { capture: true, signal });
      this.addEventListener('load', this.queueUpdate, { capture: true, signal });
      this.addEventListener('animationend', this.queueUpdate, { signal });
      this.addEventListener('transitionend', this.queueUpdate, { signal });
      window.addEventListener('resize', this.queueUpdate, { passive: true, signal });
      const firstCard = this.track.firstElementChild;
      this.media = firstCard?.querySelector('.card__inner') ||
        firstCard?.querySelector('.card__media, .media') || firstCard;
      this.resizeObserver = new ResizeObserver(this.queueUpdate);
      this.resizeObserver.observe(this.slider);
      this.resizeObserver.observe(this.track);
      if (this.media) this.resizeObserver.observe(this.media);
      this.update();
    }

    initDesktopControls(signal) {
      const controls = this.slider.querySelector(':scope > .wl-desktop-controls');
      this.desktopButtons = [];
      if (!controls) return;
      this.buttonObserver = new MutationObserver(() => this.syncDesktopControls());
      for (const [selector, name] of [['[data-wl-previous]', 'previous'], ['[data-wl-next]', 'next']]) {
        const button = controls.querySelector(selector);
        if (!button) continue;
        const nativeButton = this.slider.querySelector(`:scope > .slider-buttons > button[name="${name}"]`);
        this.desktopButtons.push({ button, nativeButton });
        button.addEventListener('click', event => {
          event.preventDefault();
          if (this.desktop.matches && nativeButton && !nativeButton.disabled) nativeButton.click();
          this.syncDesktopControls();
        }, { signal });
        if (nativeButton) this.buttonObserver.observe(nativeButton, { attributes: true, attributeFilter: ['disabled'] });
      }
      this.track.addEventListener('scroll', () => this.syncDesktopControls(), { passive: true, signal });
      this.syncDesktopControls();
    }

    syncDesktopControls() {
      for (const { button, nativeButton } of this.desktopButtons || []) {
        button.disabled = !nativeButton || nativeButton.disabled;
      }
    }

    canDrag() {
      return this.desktop.matches && this.track.scrollWidth > this.track.clientWidth + 2;
    }

    isControl(target) {
      return target instanceof Element && target.closest(
        'button, input, textarea, select, option, label, summary, [role="button"], ' +
        '[contenteditable]:not([contenteditable="false"]), modal-opener, .wl-quick-buy-trigger, .quick-add'
      );
    }

    update() {
      if (!this.isConnected) return;
      this.slider.dataset.wlOverflow = String(this.canDrag());
      if (this.media) {
        const mediaRect = this.media.getBoundingClientRect();
        const sliderRect = this.slider.getBoundingClientRect();
        const top = mediaRect.top - sliderRect.top + mediaRect.height / 2 - this.slider.clientTop;
        this.slider.style.setProperty('--wl-arrow-top', `${Math.max(0, top)}px`);
      }
      if (!this.canDrag()) this.finishDrag();
      this.syncDesktopControls();
    }

    startDrag(event) {
      this.suppressUntil = 0;
      if (event.pointerType !== 'mouse' || event.button !== 0 || !event.isPrimary ||
          event.ctrlKey || event.metaKey || event.altKey || event.shiftKey ||
          !this.canDrag() || this.isControl(event.target)) return;
      this.finishDrag();
      this.drag = {
        id: event.pointerId, x: event.clientX, y: event.clientY,
        scroll: this.track.scrollLeft, moved: false
      };
      this.dragController = new AbortController();
      const signal = this.dragController.signal;
      document.addEventListener('pointermove', move => this.moveDrag(move), { passive: false, signal });
      document.addEventListener('pointerup', end => {
        if (end.pointerId === this.drag?.id) this.finishDrag();
      }, { signal });
      document.addEventListener('pointercancel', end => {
        if (end.pointerId === this.drag?.id) this.finishDrag();
      }, { signal });
      this.track.addEventListener('lostpointercapture', () => this.finishDrag(), { signal });
      window.addEventListener('blur', () => this.finishDrag(), { signal });
    }

    moveDrag(event) {
      const drag = this.drag;
      if (!drag || event.pointerId !== drag.id) return;
      if (!this.desktop.matches || !(event.buttons & 1)) {
        this.finishDrag();
        return;
      }
      const dx = event.clientX - drag.x;
      const dy = event.clientY - drag.y;
      if (!drag.moved) {
        if (Math.abs(dy) > 12 && Math.abs(dy) > Math.abs(dx)) {
          this.finishDrag();
          return;
        }
        if (Math.abs(dx) < 6 || Math.abs(dx) < Math.abs(dy)) return;
        drag.moved = true;
        drag.styles = ['scroll-snap-type', 'scroll-behavior', 'user-select'].map(property => [
          property, this.track.style.getPropertyValue(property), this.track.style.getPropertyPriority(property)
        ]);
        this.track.style.setProperty('scroll-snap-type', 'none', 'important');
        this.track.style.setProperty('scroll-behavior', 'auto', 'important');
        this.track.style.setProperty('user-select', 'none', 'important');
        this.track.dataset.wlDragging = 'true';
        window.getSelection()?.removeAllRanges();
        this.track.setPointerCapture(drag.id);
      }
      event.preventDefault();
      this.track.scrollLeft = drag.scroll - dx;
    }

    finishDrag() {
      const drag = this.drag;
      this.drag = null;
      this.dragController?.abort();
      this.dragController = null;
      if (!drag) return;
      if (drag.moved) {
        this.suppressUntil = performance.now() + 400;
        for (const [property, value, priority] of drag.styles) {
          if (value) this.track.style.setProperty(property, value, priority);
          else this.track.style.removeProperty(property);
        }
        delete this.track.dataset.wlDragging;
      }
      if (this.track.hasPointerCapture(drag.id)) this.track.releasePointerCapture(drag.id);
    }

    disconnectedCallback() {
      cancelAnimationFrame(this.initFrame);
      cancelAnimationFrame(this.updateFrame);
      this.connectionController?.abort();
      this.finishDrag();
      this.controller?.abort();
      this.controller = null;
      this.resizeObserver?.disconnect();
      this.buttonObserver?.disconnect();
      if (this.slider) {
        delete this.slider.dataset.wlOverflow;
        this.slider.style.removeProperty('--wl-arrow-top');
      }
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }
    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};
      this.setHeaderHeight();
      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);
      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');
      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);
      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);
      this.createObserver();

      this.wlEnabled = this.dataset.wlEnabled === 'true';
      if (this.wlEnabled) {
        this.wlMain = document.getElementById('MainContent');
        this.wlHero = this.dataset.wlHome === 'true' && !!this.wlMain?.firstElementChild?.querySelector('.banner');
        this.header.classList.toggle('wl-home-hero', this.wlHero);
        if (this.wlHero) this.wlMain.classList.add('wl-hero-content');
        this.wlToggleHandler = () => {
          const open = [...this.querySelectorAll('details[open]')].some((details) =>
            details.closest('header-menu, header-drawer, details-modal')
          );
          this.header.classList.toggle('wl-panel-open', open);
        };
        this.addEventListener('toggle', this.wlToggleHandler, true);
        this.wlResizeObserver = new ResizeObserver(() => this.setHeaderHeight());
        this.wlResizeObserver.observe(this.header);
        this.setHeaderHeight();
        this.onScroll();
      }

    }
    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }
    disconnectedCallback() {
      this.wlResizeObserver?.disconnect();
      this.removeEventListener('toggle', this.wlToggleHandler, true);
      if (this.wlHero) this.wlMain?.classList.remove('wl-hero-content');
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }
    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });
      observer.observe(this.header);
    }
    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      if (this.wlEnabled) {
        this.header.classList.toggle('wl-scrolled', scrollTop > 4);
        this.header.classList.remove('shopify-section-header-hidden');
        this.currentScrollTop = scrollTop;
        return;
      }
      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;
      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);
          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);
          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }
      this.currentScrollTop = scrollTop;
    }
    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }
    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }
    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }
    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }
    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }
  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;
      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );
  if (!customElements.get('sticky-header')) customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["woodenlux-collection-carousel"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('wl-collection-carousel')) {
    customElements.define('wl-collection-carousel', class extends HTMLElement {
      connectedCallback() {
        this.abortController?.abort();
        this.controlsObserver?.disconnect();
        this.cardsObserver?.disconnect();
        cancelAnimationFrame(this.controlsFrame);
        const track = this.querySelector('.wl-collections__track');
        if (!track) return;
        this.abortController = new AbortController();
        const options = { signal: this.abortController.signal };
        const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
        const move = (direction) => {
          const firstCard = track.firstElementChild;
          if (!firstCard) return;
          const gap = parseFloat(getComputedStyle(track).columnGap) || 0;
          track.scrollBy({
            left: direction * (firstCard.getBoundingClientRect().width + gap),
            behavior: reducedMotion.matches ? 'auto' : 'smooth'
          });
        };
        const carousel = this.querySelector('.wl-collections__carousel');
        const previous = this.querySelector('[data-wl-previous]');
        const next = this.querySelector('[data-wl-next]');
        const desktop = window.matchMedia('(min-width: 990px)');
        const media = track.querySelector('.wl-collections__media');
        const updateControls = () => {
          const maximum = Math.max(0, track.scrollWidth - track.clientWidth);
          const overflowing = desktop.matches && maximum > 2;
          carousel.dataset.wlOverflow = String(overflowing);
          previous.disabled = !overflowing || track.scrollLeft <= 2;
          next.disabled = !overflowing || track.scrollLeft >= maximum - 2;
          if (overflowing && media) {
            const image = media.getBoundingClientRect();
            const frame = carousel.getBoundingClientRect();
            carousel.style.setProperty('--wl-arrow-top', `${image.top - frame.top + image.height / 2}px`);
          }
        };
        previous.addEventListener('click', () => { if (desktop.matches) move(-1); }, options);
        next.addEventListener('click', () => { if (desktop.matches) move(1); }, options);
        track.addEventListener('scroll', updateControls, { ...options, passive: true });
        window.addEventListener('resize', updateControls, options);
        this.controlsObserver = new ResizeObserver(updateControls);
        this.controlsObserver.observe(track);
        this.cardsObserver = new MutationObserver(updateControls);
        this.cardsObserver.observe(track, { childList: true });
        if (media) this.controlsObserver.observe(media);
        this.controlsFrame = requestAnimationFrame(updateControls);
        track.addEventListener('keydown', event => {
          if (event.target !== track) return;
          if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {
            event.preventDefault();
            move(event.key === 'ArrowRight' ? 1 : -1);
          }
          if (event.key === 'Home' || event.key === 'End') {
            event.preventDefault();
            track.scrollTo({ left: event.key === 'Home' ? 0 : track.scrollWidth });
          }
        }, options);
        // Phones and tablets use native touch scrolling. Mouse dragging is separate.
        let drag = null;
        let suppressClickUntil = 0;
        track.addEventListener('dragstart', event => event.preventDefault(), options);
        track.addEventListener('pointerdown', event => {
          if (event.pointerType !== 'mouse' || event.button !== 0) return;
          if (track.scrollWidth <= track.clientWidth + 2) return;
          suppressClickUntil = 0;
          drag = { id: event.pointerId, x: event.clientX, left: track.scrollLeft, moved: false };
        }, options);
        document.addEventListener('pointermove', event => {
          if (!drag || event.pointerId !== drag.id) return;
          const distance = event.clientX - drag.x;
          if (!drag.moved && Math.abs(distance) < 6) return;
          if (!drag.moved) {
            drag.moved = true;
            track.classList.add('is-dragging');
          }
          event.preventDefault();
          track.scrollLeft = drag.left - distance;
        }, options);
        const finish = event => {
          if (!drag || (event.pointerId !== undefined && event.pointerId !== drag.id)) return;
          if (drag.moved) suppressClickUntil = performance.now() + 400;
          drag = null;
          track.classList.remove('is-dragging');
        };
        document.addEventListener('pointerup', finish, options);
        document.addEventListener('pointercancel', finish, options);
        window.addEventListener('blur', finish, options);
        track.addEventListener('click', event => {
          if (performance.now() < suppressClickUntil) {
            event.preventDefault();
            event.stopPropagation();
          }
        }, { ...options, capture: true });
      }
      disconnectedCallback() {
        this.abortController?.abort();
        this.controlsObserver?.disconnect();
        this.cardsObserver?.disconnect();
        cancelAnimationFrame(this.controlsFrame);
        this.querySelector('.wl-collections__track')?.classList.remove('is-dragging');
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["woodenlux-sale-banner"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('wl-sale-banner')) {
    customElements.define('wl-sale-banner', class extends HTMLElement {
      connectedCallback() {
        this.abortController?.abort();
        if (this.dataset.scrollZoom !== 'true' || !this.querySelector('.wl-sale__picture')) return;
        this.abortController = new AbortController();
        const options = { signal: this.abortController.signal };
        const motionPreference = window.matchMedia('(prefers-reduced-motion: reduce)');
        const mobile = window.matchMedia('(max-width: 749px)');
        const update = () => {
          this.frame = null;
          if (motionPreference.matches) {
            this.style.setProperty('--wl-sale-scale', '1');
            return;
          }
          const bounds = this.getBoundingClientRect();
          const viewportHeight = window.innerHeight;
          const progress = Math.max(0, Math.min(1,
            (viewportHeight - bounds.top) / (viewportHeight + bounds.height)
          ));
          const amount = mobile.matches ? 0.06 : 0.12;
          this.style.setProperty('--wl-sale-scale', (1 + progress * amount).toFixed(4));
        };
        const schedule = () => {
          if (this.frame == null) this.frame = requestAnimationFrame(update);
        };
        window.addEventListener('scroll', schedule, { ...options, passive: true });
        window.addEventListener('resize', schedule, options);
        motionPreference.addEventListener('change', schedule, options);
        update();
      }
      disconnectedCallback() {
        this.abortController?.abort();
        if (this.frame != null) cancelAnimationFrame(this.frame);
        this.frame = null;
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
